import type { TFunction } from "i18next";

import type { ReportedCatalogue } from "../../../api/connectorStatus";

/** What of the agent's model catalogue did not reach the report, in counts (R2-4, R2-5); `null` when all did. */
export function catalogueNote(t: TFunction, catalogue: ReportedCatalogue | null): string | null {
  if (catalogue === null) return null;
  if (catalogue.state === "failed") return t("connectors.routes.catalogueFailed");
  if (catalogue.invalid === 0 && catalogue.overBudget === 0) return null;
  return t("connectors.routes.catalogueLeftOut", { reported: t("connectors.routes.factCount", { count: catalogue.reported }), invalid: catalogue.invalid, overBudget: catalogue.overBudget });
}

/** Optional facts the report's shared limit left out (R4-2): said, never a block; `null` when none. */
export function omittedNote(t: TFunction, omitted: number): string | null {
  return omitted === 0 ? null : t("connectors.routes.factsOmitted", { count: omitted });
}

export function joinedNotes(...notes: (string | null)[]): string | null {
  const shown = notes.filter((note): note is string => note !== null);
  return shown.length === 0 ? null : shown.join(" ");
}
